import { controls,grouped } from "../controls";
const ac_loan_infos = {
label: "Ac Loan Infos",
pageLabel: "Ac Loan Infos",starting: true,url: "autogen",
formActions: { edit: { allow: true },delete:{allow:true} },
pageType: "history",
filter:[
]
,form:[
...controls.magicDateLabel({ tab: "general", label: "Sanction Date",target: "sanction_date",star:true}),
...controls.magicDate({ tab: "general", name: "sanction_date", dateType: "ontype",isRequired:true }),
...controls.displayText({ tab: "general", label: "",width:"col-sm-2"}),
...controls.displayText({ tab: "general", label: "Sanction Amount"}),
...controls.floatOnly({ tab: "general",  placeHolder: "", name: "sanction_amount",maxlength:18}),
...controls.displayText({ tab: "general", label: "",width:"col-sm-2"}),
...controls.displayText({ tab: "general", label: "Sanction Letter No",star:false}),
...controls.text({ tab: "general",  placeHolder: "", name: "sanction_letter_no",maxlength:20 ,isReadOnly:"edit" }),
...controls.displayText({ tab: "general", label: "",width:"col-sm-2"}),
...controls.displayText({ tab: "general", label: "Sanction By",star:false}),
...controls.autoComplete({tab: "general", name: "loan_sanctioner_type_code", width: "col-sm-2",controlType: "LoanSanctionerType"}),
...controls.displayText({ tab: "general", label: ""}),
...controls.displayText({ tab: "general", label: "Disbursed Amount"}),
...controls.floatOnly({ tab: "general",  placeHolder: "", name: "disb_amount",maxlength:18 ,isReadOnly:"edit" ,isReadOnly:true}),
...controls.displayText({ tab: "general", label: "",width:"col-sm-2"}),
...controls.displayText({ tab: "general", label: "Purpose",star:false}),
...controls.oc({ tab: "general", c: "Purpose", placeHolder: "Purpose Code", name: "purpose_code",fastpath: "purposes",hidden:false}),
...controls.showData({ tab: "general", displaytype: "capital", data: "purpose_display"}),
...controls.displayText({ tab: "general", label: "Priority Segment",star:false}),
...controls.oc({ tab: "general", c: "Priority", placeHolder: "Priority Segment", name: "priority_code",fastpath: "priorities",hidden:false}),
...controls.showData({ tab: "general", displaytype: "capital", data: "priority_display"}),
...controls.displayText({ tab: "general", label: "Priority Sector",star:false}),
...controls.oc({ tab: "general", c: "PrioritySector", placeHolder: "Priority Sector Code", name: "priority_sector_code",fastpath: "priority_sectors",hidden:false}),
...controls.showData({ tab: "general", displaytype: "capital", data: "priority_sector_display"}),
...controls.displayText({ tab: "general", label: "Loan Health Type",star:false}),
...controls.oc({ tab: "general", c: "LoanHealthType", placeHolder: "Loan Health Type Code", name: "loan_health_type_code",fastpath: "loan_health_types",hidden:false}),
...controls.showData({ tab: "general", displaytype: "capital", data: "loan_health_type_display"}),
...controls.displayText({ tab: "general", label: "Loan Category",star:false}),
...controls.autoComplete({tab: "general", name: "loan_category_code", width: "col-sm-2",controlType: "LoanCategory"}),
...controls.displayText({ tab: "general", label: ""}),
...controls.displayText({ tab: "general", label: "Industry Type",star:false}),
...controls.autoComplete({tab: "general", name: "industry_type_code", width: "col-sm-2",controlType: "IndustryType"}),
...controls.displayText({ tab: "general", label: ""}),
...controls.displayText({ tab: "general", label: "",width:"col-sm-2"}),
...controls.checkBox({ tab: "general", label: "Is Secured",default:false, name: "is_secured",width:"col-sm-4" }),
...controls.displayText({ tab: "general", label: "",width:"col-sm-2"}),
...controls.checkBox({ tab: "general", label: "Is related to director",default:false, name: "is_relative_director",width:"col-sm-4" }),
...controls.displayText({ tab: "general", label: "Relation",star:false,parents:[{"name": "is_relative_director", "match": "exists"}]}),
...controls.autoComplete({tab: "general", name: "relation_code", width: "col-sm-2",controlType: "Relation"}),
...controls.displayText({ tab: "general", label: ""}),
...controls.displayText({ tab: "general", label: "director customer id",star:false,parents:[{"name": "is_relative_director", "match": "exists"}]}),
...controls.oc({ tab: "general", c: "Customer", placeHolder: "director customer id", name: "director_customer_code",fastpath: "customers",parents:[{"name": "is_relative_director", "match": "exists"}],hidden:false}),
...controls.showData({ tab: "general", displaytype: "capital", data: "director_customer_display",parents:[{"name": "is_relative_director", "match": "exists"}]}),
]
,history:{
perPage: 10,
reportHeader: "Ac Loan Infos",
pdfProps: { pageSize: "A4", pageOrientation: "portrait" },
clickable: true,
displayColumns: [
{Header: "Sr",type: "autoinc",accessor: "srno",align: "center",width: 30},
{Header: "Sanction Date",accessor: "sanction_date",type:'date'},
{Header: "Sanction Amount",accessor: "sanction_amount",},
{Header: "Is Secured",accessor: "is_secured",type:'tick'},
{Header: "Purpose Id",accessor: "purpose_id",},
{Header: "Priority Segment",accessor: "priority_id",},
{Header: "Health Id",accessor: "health_id",},
{Header: "Loan Category Id",accessor: "loan_category_id",},
{Header: "Industry Type Id",accessor: "industry_type_id",},
{Header: "Is Director",accessor: "is_director",type:'tick'},
{Header: "Is related to director",accessor: "is_relative_director",type:'tick'},
{Header: "Director Relation Id",accessor: "director_relation_id",},
{Header: "director customer id",accessor: "director_customer_id",},
{Header: "Priority Sector Id",accessor: "priority_sector_id",},
]}};
export default ac_loan_infos;